<template>
  <div class="Profile">

    <b-list-group class="p-2">
      <b-container>
        <b-row>
          <b-col lg="12" class="text-light-black mb-3 container" style="font-size: 15px">
            <h2> Ingrese los datos de la transferencia</h2>
            <br>
            <p class="mx-md-5 px-md-5" style="color:#CC163C;">
              Envianos un email a desk.bridgebonds@gmail.com para que un asesor te guie <br> en el proceso de una manera
              personalizada
            </p>
          </b-col>
          <b-col lg="6" class="mb-3">
            <b-row align-h="center">
              <b-col lg="10" md="10" sm="10" cols="12">
                <h5 class="text-light-black text-left">
                  Cuenta a depositar
                </h5>
                <b-form-select id="input-live" v-model="account_id" size="sm" class="shadow-sm bg-white rounded"
                  :options="account" disabled trim></b-form-select>
              </b-col>
              <b-col lg="10" md="10" sm="10" cols="12">
                <h5 class="text-light-black text-left mt-3">Monto (debe ser mayor a $500)</h5>
                <b-form-input id="input-live" v-model="amount" type="number" size="sm" min="0"
                  class="shadow-sm bg-white rounded " trim></b-form-input>
              </b-col>

              <b-col lg="10" md="10" sm="10" cols="12">
                <h5 class="text-light-black mt-3 text-left">
                  Fecha de pago
                </h5>
                <b-form-datepicker class="text-left" style="font-size: 14px" id="datepicker-dateformat"
                  :date-format-options="{
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric',
                    weekday: 'short',
                  }" :max="date_max" locale="es" placeholder="Fecha de pago"
                  v-model="date_start_select"></b-form-datepicker>
              </b-col>

              <b-col lg="10" md="10" sm="10" cols="12">
                <h5 class="text-light-black mt-3 text-left ">
                  Número de confirmación
                </h5>

                <b-form-input v-model="RefNumber" id="RefNumber" size="sm"
                  class="shadow-sm bg-white rounded "></b-form-input>
              </b-col>
              <b-col lg="6" md="6" sm="9" cols="12"> </b-col>
              <div></div>

              <b-col lg="10" md="10" sm="10" cols="12">
                <h5 class="text-light-black mt-3 text-left">
                  Banco del titular
                </h5>
                <b-form-input v-model="BankName" placeholder="" size="sm"
                  class="shadow-sm bg-white rounded "></b-form-input>
                <!-- <b-form-select
                      id="input-live"
                      v-model="bank_id"
                      :options="bankTmp"
                      size="sm"
                      class="shadow-sm bg-white rounded"
                      trim
                      @input="bankbyId()"
                    ></b-form-select> -->
              </b-col>
              <b-col lg="10" md="10" sm="10" cols="12">
                <h5 class="text-light-black text-left mt-3">
                  Nombre del titular
                </h5>
                <b-form-input v-model="name" placeholder="" size="sm" class="shadow-sm bg-white rounded"></b-form-input>
              </b-col>
              <b-col lg="10" md="10" sm="10" cols="12">
                <h5 class="text-light-black text-left mt-3">
                  Correo del titular
                </h5>
                <b-form-input v-model="email" type="email" placeholder="" size="sm"
                  class="shadow-sm bg-white rounded"></b-form-input>
              </b-col>
              <b-col lg="10" md="10" sm="10" cols="12">
                <h5 class="text-light-black text-left mt-3">
                  Teléfono del titular
                </h5>
                <b-form-input v-model="phone" type="number" placeholder="" size="sm"
                  class="shadow-sm bg-white rounded"></b-form-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="6">
            <b-row align-v="center" align-h="center">
              <b-col lg="5" md="5" sm="5" cols="12">
                <h3 class="text-light-black text-left" style="font-size: 20px">
                  Cuenta bancaria
                </h3>
              </b-col>
              <b-col lg="7" md="7" sm="7" cols="12">
                <b-form-select id="input-live" v-model="Companybank_id" :options="bankCompany" size="sm"
                  class="shadow-sm bg-white rounded" @input="CompanyBankbyId()" trim></b-form-select>
              </b-col>
              <b-col lg="12" md="12" sm="12" cols="12" v-if="bankData">
                <div class="text-light-black text-left">
                  {{ bankData.name }}
                </div>
                <div class="text-light-black text-left">
                  {{ bankData.bank_name }}
                </div>
                <div class="text-light-black text-left">
                  Número de cuenta: {{ bankData.acc }}
                </div>
                <div class="text-light-black text-left">
                  Zelle: {{ bankData.email }}
                </div>
                <div class="text-light-black text-left">
                  Swift: {{ bankData.swift }} <br> {{ type_account }}
                </div>

              </b-col>
            </b-row>

            <b-row align-v="center" align-h="center" class="mt-4">
              <b-col lg="6">
                Adjuntar el comprobante
                <b-button variant="white" v-if="!picture" @click="changePicture()">
                  <svg class="p-5 shadow-lg" style="background-color: #f8f8f8; border-radius: 10px"
                    xmlns="http://www.w3.org/2000/svg" height="200px" viewBox="0 0 24 24" width="200px" fill="#C4C4C4">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                      d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z" />
                  </svg>
                </b-button>

                <img v-if="picture" :src="picture" height="200px" width="200px" style="border-radius: 10px" alt="" />
                <b-button @click="changePicture()" v-if="picture" class="btn-card-color mt-3"
                  style="border-radius: 8px; border: none">
                  <span class="text-font-white"> Cambiar</span>
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mt-4">
              <b-col>
                <b-button style="border-radius: 8px; border: none"
                  class="btn-card-color mt-3 text-left pl-5 pr-5 pb-2 pt-2" size="lg" @click="reportPayment()">
                  <span v-if="!progress" class="text-font-white" style="font-size: 18px">Reportar pago</span>
                  <span v-if="progress" class="text-font-white"><b-spinner type="grow"
                      label="Spinning"></b-spinner>Cargando</span>
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </b-list-group>


  </div>
</template>

<script>
import Cookies from "js-cookie";
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "Profile",
  data() {
    return {
      date_max: new Date(),
      account_id: null,
      progress: false,
      amount: "",
      date_start_select: null,
      BankName: '',
      email: "",
      RefNumber: "",
      bank_id: null,
      Companybank_id: null,
      name: "",
      phone: "",
      date: "",
      picture: null,
      file1: null,
      id: Cookies.get("id"),
      disable: null,
      title: "",
      bank: [],
      bankTmp: [],
      user: [],
      account: [],
      bankCompany: [],
      bankData: [],
      type_account: '',
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.me,
      main_account: (state) => state.main_account,
    }),
    checkAuth() {
      return this.code2.length == 6 ? false : true;
    },
  },
  mounted() {
    this.AllAccount();
    this.AllCompanyBank()
  },

  methods: {
    ...mapActions([
      "getAccount",
      "UpdatePicture",
      "getBank",
      "getBankbyId",
      "ReportPaytoAccount",
      "getCompanyBank",
      "getCompanyBankbyId"
    ]),
    resetModal() {
      this.step1 = 1;
    },
    CompanyBankbyId() {
      this.getCompanyBankbyId(this.Companybank_id).then((response) => {
        console.log(response);
        if (response.code == 200) {
          this.bankData = response.data
          this.type_account = response.data.type.name
        }
      });
    },
    AllCompanyBank() {
      this.getCompanyBank().then((response) => {
        console.log(response);
        if (response.code == 200) {

          response.data.forEach((element) => {
            this.Companybank_id = element.id
            this.bankCompany.push({
              value: String(element.id),
              text: element.name,
            });
          });
        }
      });
    },
    /* bankbyId() {
      this.getBankbyId(this.bank_id).then((response) => {
        console.log(response);
        if (response.code == 200) {
          this.name =
            response.data.user.first_name + " " + response.data.user.last_name;
          this.email = response.data.email;
          this.phone = response.data.phone;
        }
      });
    },
    AllBank() {
      this.getBank(this.id)
        .then((response) => {
          console.log(response);
          if (response.code == 200) {
            this.bank = response.data;
            response.data.forEach((element) => {
              this.bankTmp.push({
                value: String(element.id),
                text: element.name,
              });
            });
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Ha ocurrido un error, intente más tarde",
            icon: "error",
          });
        });
    }, */
    AllAccount() {
      this.getAccount(this.id)
        .then((response) => {
          console.log(response);
          if (response.code == 200) {

            response.data.forEach((element) => {
              this.account_id = String(element.id)

              this.account.push({
                value: String(element.id),
                text: element.name,
              });
            });
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Ha ocurrido un error, intente más tarde",
            icon: "error",
          });
        });
    },

    reportPayment() {
      if (
        this.name == "" ||
        this.BankName == "" ||
        this.email == "" ||
        this.phone == "" ||
        this.date_start_select == null ||
        this.RefNumber == ""
      ) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debes llenar todos los campos para continuar",
          icon: "warning",
        });
      } else {
        if (this.amount <= 0) {
          Swal.fire({
            title: "¡Atención!",
            text: "El monto a registrar debe ser mayor a 0",
            icon: "warning",
          });
        } else if (!this.picture) {
          Swal.fire({
            title: "¡Atención!",
            text: "Debe adjuntar un comprobante del voucher",
            icon: "warning",
          });
        } else {
          this.progress = true;
          let datos = new FormData();
          datos.append("user_account_id", this.account_id);
          datos.append("company_bank_id", this.Companybank_id);
          datos.append("payment_method_id", "2");
          datos.append("bank", this.BankName);
          datos.append("amount", this.amount);
          datos.append("reference", this.RefNumber);
          datos.append("date_payment", this.date_start_select);
          datos.append("voucher", this.file1);
          datos.append("name", this.name);
          datos.append("email", this.email);
          datos.append("phone", this.phone);

          this.ReportPaytoAccount(datos)
            .then((response) => {
              console.log(response);
              if (response.code == 200) {
                Swal.fire({
                  title: "Listo",
                  text: "Tu pago ha sido reportado correctamente",
                  icon: "success",
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.progress = false;
                this.amount = "";
                this.date_start_select = null;
                this.email = "";
                this.RefNumber = "";
                this.BankName = "";
                this.name = "";
                this.phone = "";
                this.date = "";
                this.picture = null;
                this.$router.push('/history/' + this.account_id)
              } else if (response.message == "The amount must be over 500") {
                Swal.fire({
                  title: "¡Atención!",
                  text: "El monto debe ser mayor a $500",
                  icon: "warning",
                });
                this.progress = false;
              } else {
                Swal.fire({
                  title: "¡Atención!",
                  text: "Error en las validaciones",
                  icon: "warning",
                });
                this.progress = false;
              }
            })
            .catch((error) => {
              console.log(error);
              Swal.fire({
                title: "Error",
                text: "Ha ocurrido un error, intente más tarde",
                icon: "error",
              });
            });
        }

      }
    },
    async changePicture() {
      const { value: file } = await Swal.fire({
        title: "Seleccionar una imagen",
        input: "file",
        inputAttributes: {
          accept: "image/*",
          "aria-label": "Upload your profile picture",
        },
      });

      if (file) {
        console.log(file);
        this.progress = true;

        const reader = new FileReader();
        reader.onload = (e) => {

          this.picture = e.target.result;
          this.file1 = file;
          this.progress = false;
        };
        reader.readAsDataURL(file);
      }
    },
  },
};
</script>
<style scoped>
.card-header:first-child {
  border-radius: 15px 15px 0 0;
}
</style>